import { useState } from "react";
import { toast } from "./utils/appToast";

const TIENDA_PEABODY_URL = "https://listado.mercadolibre.com.ar/tienda/peabody/";
const HISTORIA_PEABODY_URL = "https://peabody.com.ar/historia/";
const NOVEDADES_PEABODY_URL = "https://peabody.com.ar/novedades";
const RECETAS_PEABODY_URL = "https://peabody.com.ar/recetas";
const WHATSAPP_CONTACT_URL = "https://api.whatsapp.com/send/?phone=5491126726707&text&type=phone_number&app_absent=0";
const REPUESTOS_PEABODY_URL = "https://peabody.com.ar/servicio-tecnico/repuestos";
const NEWSLETTER_FUNCTION_URL =
  process.env.REACT_APP_NEWSLETTER_FUNCTION_URL ||
  "/api/newsletter-subscribe";

export default function Footer() {
  const [mobileFooterSections, setMobileFooterSections] = useState({
    acerca: false,
    atencion: false,
  });
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [showNewsletterModal, setShowNewsletterModal] = useState(false);
  const [newsletterModalInfo, setNewsletterModalInfo] = useState({
    title: "¡Te inscribiste a nuestro newsletter!",
    message: "Recibirás todas nuestras novedades",
  });
  const [newsletterSubmitting, setNewsletterSubmitting] = useState(false);

  const mobileFooterConfig = [
    {
      key: "acerca",
      title: "Acerca de Peabody",
      links: ["Tienda", "Nuestra Historia", "Novedades", "Recetas"],
    },
    {
      key: "atencion",
      title: "Atención al cliente",
      links: [
        "Contactate con nosotros",
        "Encontrá tu servicio técnico más cercano",
        "Pedí tu repuesto y accesorio",
      ],
    },
  ];

  const toggleMobileFooterSection = (key) => {
    setMobileFooterSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleNewsletterSubscribe = async () => {
    const email = String(newsletterEmail || "").trim();
    if (!email) {
      toast.error("Ingresa un email para suscribirte.");
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      toast.error("Ingresa un email válido.");
      return;
    }

    try {
      setNewsletterSubmitting(true);
      const response = await fetch(NEWSLETTER_FUNCTION_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error(`Newsletter request failed (${response.status})`);
      }

      setNewsletterModalInfo({
        title: "¡Te inscribiste a nuestro newsletter!",
        message: "Recibirás todas nuestras novedades",
      });
      setShowNewsletterModal(true);
      setNewsletterEmail("");
    } catch (error) {
      console.error("Error al suscribir email en newsletter:", error);
      setNewsletterModalInfo({
        title: "No pudimos completar el registro",
        message: "No pudimos completar el registro en este momento. Por favor volvé a intentarlo más tarde",
      });
      setShowNewsletterModal(true);
    } finally {
      setNewsletterSubmitting(false);
    }
  };

  const getFooterLinkProps = (sectionKey, item) => {
    const isTiendaLink = sectionKey === "acerca" && item === "Tienda";
    const isHistoriaLink = sectionKey === "acerca" && item === "Nuestra Historia";
    const isNovedadesLink = sectionKey === "acerca" && item === "Novedades";
    const isRecetasLink = sectionKey === "acerca" && item === "Recetas";
    const isWhatsappContactLink = sectionKey === "atencion" && item === "Contactar con nosotros";
    const isRepuestosLink = sectionKey === "atencion" && item === "Pedí tu repuesto y accesorio";
    const isExternal = isTiendaLink || isHistoriaLink || isNovedadesLink || isRecetasLink || isWhatsappContactLink || isRepuestosLink;

    return {
      href: isTiendaLink
        ? TIENDA_PEABODY_URL
        : isHistoriaLink
        ? HISTORIA_PEABODY_URL
        : isNovedadesLink
        ? NOVEDADES_PEABODY_URL
        : isRecetasLink
        ? RECETAS_PEABODY_URL
        : isWhatsappContactLink
        ? WHATSAPP_CONTACT_URL
        : isRepuestosLink
        ? REPUESTOS_PEABODY_URL
        : "#",
      target: isExternal ? "_blank" : undefined,
      rel: isExternal ? "noopener noreferrer" : undefined,
    };
  };

  return (
    <footer className="mt-auto bg-white w-full relative z-40">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="lg:hidden">
          <div className="pt-4 pb-4 border-b border-gray-200">
            <div className="group relative w-full overflow-hidden rounded-2xl border border-peabodyBlue/30 bg-gradient-to-br from-peabodyBlue to-[#1f2937] p-4 text-white shadow-lg shadow-peabodyBlue/25">
              <div className="pointer-events-none absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.2s_ease-out_1]" />
              <h5 className="text-xl font-semibold mb-2 leading-tight font-sans">Suscribite al Newsletter</h5>
              <p className="text-xs leading-snug text-white/90 mb-2.5 font-sans">
                Conocé antes que nadie los lanzamientos, recetas y mucho más.
              </p>
              <div className="flex gap-2 items-center">
                <input
                  type="email"
                  id="newsletter-email-mobile"
                  name="newsletterEmailMobile"
                  className="w-full px-3 py-2 bg-white/95 border border-white/60 text-gray-700 rounded-xl focus:ring-2 focus:ring-white/80 focus:border-transparent outline-none transition-all duration-200 placeholder:text-gray-400 text-sm font-sans"
                  placeholder="Ingresa tu email"
                  autoComplete="email"
                  value={newsletterEmail}
                  onChange={(e) => setNewsletterEmail(e.target.value)}
                />
                <button
                  type="button"
                  onClick={handleNewsletterSubscribe}
                  disabled={newsletterSubmitting}
                  className="shrink-0 rounded-xl border border-white/80 bg-white px-4 py-2 text-xs font-bold text-black shadow-md shadow-black/30 transition-colors duration-200 hover:bg-gray-100 disabled:opacity-70 font-sans"
                >
                  {newsletterSubmitting ? "Enviando..." : "Suscribirme"}
                </button>
              </div>
            </div>
          </div>

          {mobileFooterConfig.map((section, index) => (
            <div
              key={section.key}
              className={index < mobileFooterConfig.length - 1 ? "border-b border-gray-200" : ""}
            >
              <button
                type="button"
                className="w-full flex items-center justify-between py-3.5 text-left"
                onClick={() => toggleMobileFooterSection(section.key)}
              >
                <span className="text-lg font-semibold text-peabodyDark leading-none font-sans">{section.title}</span>
                <svg
                  className={`w-4 h-4 text-peabodyDark transition-transform duration-200 ${mobileFooterSections[section.key] ? "rotate-180" : ""}`}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 9l6 6 6-6" />
                </svg>
              </button>

              {mobileFooterSections[section.key] && (
                <div className="pb-3 flex flex-col gap-1.5">
                  {section.links.map((item) => {
                    const linkProps = getFooterLinkProps(section.key, item);
                    return (
                      <a
                        key={item}
                        href={linkProps.href}
                        target={linkProps.target}
                        rel={linkProps.rel}
                        className="text-[11px] text-gray-600 hover:text-peabodyBlue transition-colors decoration-transparent font-sans"
                      >
                        {item}
                      </a>
                    );
                  })}
                </div>
              )}
            </div>
          ))}

          <div className="mt-4 pt-3 flex items-center justify-between gap-2 text-xs">
            <p className="font-semibold text-gray-500 m-0">&copy; Copyright 2026</p>
            <span className="text-gray-300">|</span>
            <a href="#" className="font-semibold text-gray-500 hover:text-peabodyBlue transition-colors decoration-transparent">
              Defensa del consumidor
            </a>
          </div>
        </div>

        <div className="hidden lg:flex lg:flex-col">
          <div className="flex lg:items-stretch gap-6">
            <div className="grid grid-cols-2 gap-3 flex-1">
              <div className="flex flex-col space-y-1">
                <h6 className="font-bold text-peabodyDark tracking-wide text-sm mb-1">Atención al Cliente</h6>
                <a href={WHATSAPP_CONTACT_URL} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-peabodyBlue text-sm transition-colors decoration-transparent">Contactate con nosotros</a>
                <a href="#" className="text-gray-500 hover:text-peabodyBlue text-sm transition-colors decoration-transparent">Encontrá tu servicio técnico más cercano</a>
                <a href={REPUESTOS_PEABODY_URL} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-peabodyBlue text-sm transition-colors decoration-transparent">Pedí tu repuesto y accesorio</a>
              </div>

              <div className="flex flex-col space-y-1">
                <h6 className="font-bold text-peabodyDark tracking-wide text-sm mb-1">Acerca de Peabody</h6>
                <a href={TIENDA_PEABODY_URL} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-peabodyBlue text-sm transition-colors decoration-transparent">Tienda</a>
                <a href={HISTORIA_PEABODY_URL} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-peabodyBlue text-sm transition-colors decoration-transparent">Nuestra Historia</a>
                <a href={NOVEDADES_PEABODY_URL} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-peabodyBlue text-sm transition-colors decoration-transparent">Novedades</a>
                <a href={RECETAS_PEABODY_URL} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-peabodyBlue text-sm transition-colors decoration-transparent">Recetas</a>
              </div>
            </div>

            <div className="w-full basis-[40%] xl:basis-[42%] max-w-[560px]">
              <div className="group relative h-full w-full overflow-hidden rounded-2xl border border-peabodyBlue/30 bg-gradient-to-br from-peabodyBlue to-[#1f2937] p-3 sm:p-4 text-white shadow-lg shadow-peabodyBlue/25">
                <div className="pointer-events-none absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.2s_ease-out_1]" />
                <h5 className="text-[1.65rem] font-bold mb-2 leading-tight">Suscribite al Newsletter</h5>
                <p className="text-sm leading-snug text-white/90 mb-3">
                  Conocé antes que nadie los lanzamientos, recetas y mucho más
                </p>
                <div className="flex gap-2 items-center">
                  <input
                    type="email"
                    id="newsletter-email-desktop"
                    name="newsletterEmailDesktop"
                    className="w-full px-3 py-2.5 bg-white/95 border border-white/60 text-gray-700 rounded-xl focus:ring-2 focus:ring-white/80 focus:border-transparent outline-none transition-all duration-200 placeholder:text-gray-400"
                    placeholder="Ingresa tu email"
                    autoComplete="email"
                    value={newsletterEmail}
                    onChange={(e) => setNewsletterEmail(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={handleNewsletterSubscribe}
                    disabled={newsletterSubmitting}
                    className="shrink-0 rounded-xl border border-white/80 bg-white px-5 py-2 text-sm font-bold text-black shadow-md shadow-black/30 transition-colors duration-200 hover:bg-gray-100 disabled:opacity-70"
                  >
                    {newsletterSubmitting ? "Enviando..." : "Suscribirme"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3 pt-3 border-t border-gray-100 flex justify-between items-center gap-1.5">
            <p className="text-xs font-semibold text-gray-400 m-0">&copy; Goldmund &reg; | Todos los Derechos reservados.</p>
          </div>
        </div>
      </div>

      {showNewsletterModal && (
        <div
          className="fixed inset-0 z-[13000] flex items-center justify-center bg-black/45 p-4 backdrop-blur-[1px]"
          role="dialog"
          aria-modal="true"
          aria-labelledby="newsletter-success-title"
          onClick={(e) => {
            if (e.target === e.currentTarget) setShowNewsletterModal(false);
          }}
        >
          <div className="w-full max-w-md overflow-hidden rounded-2xl border border-white/70 bg-white shadow-2xl shadow-black/20">
            <div className="border-b border-peabodyBlue/40 bg-gradient-to-r from-peabodyBlue to-[#1f2937] px-6 py-4">
              <h3 id="newsletter-success-title" className="mb-0 text-lg font-bold text-white">
                {newsletterModalInfo.title}
              </h3>
            </div>
            <div className="p-6">
              <p className="mb-0 text-sm text-gray-700">
                {newsletterModalInfo.message}
              </p>
            </div>
            <div className="flex justify-end border-t border-gray-100 px-6 py-4">
              <button
                type="button"
                className="rounded-xl bg-gradient-to-r from-peabodyBlue to-[#1f2937] px-5 py-2 text-sm font-semibold text-white shadow-md shadow-peabodyBlue/30 transition-all hover:shadow-lg hover:shadow-peabodyBlue/40"
                onClick={() => setShowNewsletterModal(false)}
              >
                Entendido
              </button>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}

